module.exports = __webpack_public_path__ + "static/banana-7091466ba510405d598e3858af4711af.png";